module.exports = __webpack_public_path__ + "9e029162d2d2fca8137ab8fd3cf12ffc.svg";